import { AppDispatch } from 'client/store'
import { WebsitePageDataInterface } from 'src/shared/types/website-settings-types'
import { setWebsiteSettings } from '../website-settings/website-settings-actions'

export const fetchWebsitePageDataSuccess =
  (data: WebsitePageDataInterface) => async (dispatch: AppDispatch) => {
    dispatch(setWebsiteSettings(data))
  }
